import api from './api.service';
import type { ApiResponse } from '@/types';

function unwrap<T>(res: unknown): T | undefined {
  if (!res || typeof res !== 'object') return undefined;
  const r = res as ApiResponse<T>;
  if (r.data !== undefined) return r.data as T;
  return res as T;
}

export type StoredUserPreferences = Record<string, unknown> & {
  ui_language?: string;
  document_language?: string;
  language?: string;
};

const userPreferencesService = {
  async getMine(): Promise<StoredUserPreferences | null> {
    const res = await api.get('/auth/me/preferences');
    const data = unwrap<StoredUserPreferences | string | null>(res);
    if (!data) return null;
    if (typeof data === 'string') {
      try {
        return JSON.parse(data) as StoredUserPreferences;
      } catch {
        return null;
      }
    }
    return data;
  },

  async updateMine(preferences: StoredUserPreferences): Promise<StoredUserPreferences> {
    const res = await api.put('/auth/me/preferences', preferences);
    const data = unwrap<StoredUserPreferences | string | null>(res);
    if (!data) return preferences;
    if (typeof data === 'string') {
      try {
        return JSON.parse(data) as StoredUserPreferences;
      } catch {
        return preferences;
      }
    }
    return data;
  },
};

export default userPreferencesService;
